// Constants
import { Colors } from "@ms/uno-constants/lib/local/Colors";
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
// Styles
import { concatStyleSetsWithProps, memoizeFunction, mergeStyles } from "@fluentui/react";
const ribbonHeight = "44px";
const ribbonButtonWidth = "44px";
/**
 * Helper to get styles for RichTextEditor
 * @param props Style props
 * @param customStyles Any custom style overrides
 */ export const getStyles = memoizeFunction((theme, customStyles)=>{
    const isLightTheme = theme.name === PlannerTheme.Light;
    const ribbonOverflowButton = [
        {
            ".ms-ContextualMenu-icon, .ms-ContextualMenu-itemText": {
                color: isLightTheme ? Colors.NeutralDarkGrey24 : Colors.White
            },
            ".ms-ContextualMenu-list": {
                backgroundColor: isLightTheme ? Colors.White : Colors.Black
            },
            "button.is-checked": [
                {
                    backgroundColor: isLightTheme ? Colors.White : Colors.NeutralDarkGrey24
                },
                {
                    i: {
                        color: isLightTheme ? Colors.NeutralLightGrey14 : Colors.White
                    }
                }
            ],
            "button.is-disabled": [
                {
                    color: isLightTheme ? Colors.NeutralLighter : Colors.NeutralLightGrey96
                },
                {
                    i: {
                        color: isLightTheme ? Colors.NeutralLightGrey14 : Colors.White
                    }
                }
            ],
            "button:hover, button.is-expanded": [
                {
                    backgroundColor: isLightTheme ? Colors.NeutralLight : Colors.NeutralPrimaryAlt
                },
                {
                    i: {
                        color: isLightTheme ? Colors.NeutralLightGrey14 + "!important" : Colors.White + "!important"
                    }
                }
            ]
        }
    ];
    const ribbonButtonDropDown = [
        {
            ".ms-ContextualMenu-icon, .ms-ContextualMenu-itemText": {
                color: isLightTheme ? Colors.NeutralDarkGrey24 : Colors.White
            }
        },
        {
            backgroundColor: isLightTheme ? Colors.White : Colors.Black
        },
        {
            ".ms-ContextualMenu-icon": {
                color: isLightTheme ? Colors.NeutralDarkGrey24 : Colors.White
            }
        },
        {
            "button:hover, button.is-expanded": [
                {
                    backgroundColor: isLightTheme ? Colors.NeutralLight : Colors.NeutralPrimaryAlt
                },
                {
                    i: {
                        color: isLightTheme ? Colors.NeutralLightGrey14 + "!important" : Colors.White + "!important"
                    }
                }
            ]
        }
    ];
    const ribbonButtonSubMenu = [
        {
            backgroundColor: isLightTheme ? Colors.White : Colors.Black
        }
    ];
    // Ribbon component does not expose the commin fluentUI props for customization.
    // So we have to manually overwrite the styles. (The same as for roosterjs)
    const root = [
        {
            minWidth: ribbonHeight,
            backgroundColor: "transparent",
            ".ms-CommandBar": {
                backgroundColor: "transparent"
            },
            button: [
                {
                    width: ribbonButtonWidth,
                    height: ribbonHeight
                }
            ],
            "button.is-checked, button.is-expanded": [
                {
                    backgroundColor: isLightTheme ? Colors.NeutralLighter : Colors.NeutralDarkGrey24
                },
                {
                    i: {
                        color: isLightTheme ? Colors.NeutralLightGrey14 : Colors.White
                    }
                }
            ],
            "button:hover": [
                {
                    backgroundColor: isLightTheme ? Colors.NeutralLighterAlt : Colors.NeutralDarkGrey20
                },
                {
                    i: {
                        color: isLightTheme ? Colors.NeutralLightGrey14 + "!important" : Colors.White + "!important"
                    }
                },
                {
                    ".ms-Button-menuIcon": {
                        color: isLightTheme ? Colors.NeutralDarkGrey24 : Colors.White,
                        backgrounColor: "transparent"
                    }
                }
            ],
            ".ms-Button--commandBar": [
                {
                    backgroundColor: "transparent"
                },
                {
                    ".is-disabled": [
                        {
                            color: isLightTheme ? Colors.NeutralLighter : Colors.NeutralLightGrey96
                        }
                    ]
                }
            ],
            ".ms-Button-icon, .ms-Button-menuIcon": [
                {
                    color: isLightTheme ? Colors.NeutralDarkGrey24 : Colors.White
                }
            ]
        }
    ];
    const styles = {
        root,
        ribbonOverflowButton,
        ribbonButtonDropDown,
        ribbonButtonSubMenu
    };
    return concatStyleSetsWithProps({}, styles, customStyles);
});
/**
 * Get the classnames associated with the computed styles
 * @param styles The styles for the component
 */ export const getClassNames = memoizeFunction((styles)=>({
        root: mergeStyles("ribbon", styles.root),
        ribbonOverflowButton: mergeStyles("ribbon-overflow-button", styles.ribbonOverflowButton),
        ribbonButtonDropDown: mergeStyles("ribbon-button-dropdown", styles.ribbonButtonDropDown),
        ribbonButtonSubMenu: mergeStyles("ribbon-button-submenu", styles.ribbonButtonSubMenu)
    }));
